import React from "react";
import { connectSearchBox } from "react-instantsearch-dom";

type VirtualSearchBoxProps = {
  children?: React.ReactNode;
  refine: Function;
  query?: string;
  currentRefinement?: string;
};

const SearchBox = (props: VirtualSearchBoxProps): null => {
  const { refine, query = "" } = props;

  const [searchTerms, setSearchTerms] = React.useState<string | undefined>(query || "");

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = e.currentTarget.value;
  //   setSearchTerms(value);
  // };

  // const handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
  //   setSearchTerms("");
  // };

  React.useEffect(() => {
    if (query === "" || !query) {
      setSearchTerms(query);
    }
  }, [setSearchTerms, query]);

  React.useEffect(() => {
    refine(searchTerms);
  }, [refine, searchTerms]);

  return null;
};

const VirtualSearchBox = connectSearchBox(SearchBox);

export default VirtualSearchBox;
